/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaxVatRateDto = {
    readonly _permissions?: Array<string>;
    created?: string;
    creator?: string;
    creatorId?: string;
    id?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    rate?: number;
    rateType?: TaxVatRateDto.rateType;
    validFrom?: string;
    validTo?: string;
};

export namespace TaxVatRateDto {
    export enum rateType {
        RATE_REDUCED2 = "RATE_REDUCED2",
        RATE_REDUCED = "RATE_REDUCED",
        RATE_BASE = "RATE_BASE",
        RATE_0 = "RATE_0",
        NONE = "NONE",
        UNKNOWN = "UNKNOWN",
    }
}
